import { Modal } from "bootstrap";
import bootstrapModalController from "./controller.js";

export default bootstrapModalController(Modal);
